import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import styles from './Collection.module.scss';
import actions from './actions';
import { COLORS } from '../../../../../lib/constants';
import Group from '../../../../../assets/svg/Remix/Group';
import X from '../../../../../assets/svg/Feather/X';

/*
  #TODO: Make pill component
  -- TJC - December 02, 2021
*/

export const Collection = (props) => {
  const showRemoveFromCollectionModal = () => {
    props.removeFromCollection(props.feature, props.collection);
  };

  return (
    <div className={styles.container}>
      <div className={styles.shareIcon}>
        {props.collection.isShared ? (
          <Group color={COLORS.ghGreyLtText} width={24} />
        ) : null}
      </div>
      <div className={styles.title}>{props.collection.title}</div>
      <div className={styles.close} onClick={showRemoveFromCollectionModal}>
        {props.collection.isOwner ? <X color='#fff' width={14} /> : null}
      </div>
    </div>
  );
};

Collection.propTypes = {
  collection: PropTypes.object,
  feature: PropTypes.object,
  // actions
  removeFromCollection: PropTypes.func,
};

export default connect((model) => ({}), actions)(Collection);
